<template>
  <div class="sm-img-preview-wrap">
    <div class="sm-img-preview">
      <div
        v-if="status == 'loading'"
        class="sm-img-preview__spinner"
      >
        <lottie
          :options="options"
          :height="30"
          :width="30"
        />
      </div>


      <!-- <include-svg 
        v-else-if="status == 'loaded'"
        :name="'icon-attachment'"
      /> -->
      

      <template v-else-if="status == 'loaded'">
        <vue-pdf
          v-if="blob && blob.type == 'application/pdf'"
          :src="imgSrc"
        />
        <img
          v-else
          :src="imgSrc" 
        />
      </template>

      <div
        v-else-if="status == 'error'"
        class="sm-img-preview__error"
      >
        <include-svg :name="errorIcon" />
      </div>

      <hint-block v-if="showHint">
        <template slot="hintContent">{{hintText}}</template>
      </hint-block>
    </div>
  </div>
</template>

<script>
import Lottie from 'vue-lottie';
import AnimationData from '@/assets/json/spinner.json';
import VuePdf from 'vue-pdf';
import Hint from '@/components/Hint.vue';

export default {
  name: 'img-preview',
  components: {
    'lottie': Lottie,
    'vue-pdf': VuePdf,
    'hint-block': Hint,
  },
  props: {
    src: {
      type: String,
      required: true
    },
    errorIcon: {
      type: String,
      default: 'icon-picture-error'
    },
    showHint: {
      type: Boolean,
      defaul: false
    },
    isRequested: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      status: 'loading', // values: loading, loaded, error
      imgSrc: '',
      blob: null,
      options: {
        animationData: AnimationData
      }
    }
  },
  computed: {
    hintText() {
      if (this.status == 'loading')
        return 'Loading...';

      if (this.status == 'error')
        return 'Envelope picture error';

      if (!this.isRequested)
        return 'Download envelope picture (pending customer request)'

      return 'Download envelope picture';
    }
  },
  created() {
    // this.status = 'loaded';

    // this.imgSrc = this.src


    fetch(this.src)
      .then(res => {
        return res.blob();
      })
      .then(blob => {
        if (blob && blob.type && blob.type != 'text/html') {
          this.status = 'loaded';
          this.blob = blob;
          this.imgSrc = URL.createObjectURL(blob);
        } else {
          this.status = 'error';
        }
      })
      .catch(e => {
        this.status = 'error';
      })
  }
}
</script>